module.exports = __webpack_public_path__ + "static/img/hni.a8586f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hni.svg
// module id = 192
// module chunks = 2